
<form class="form" (ngSubmit)="submit()">
  <input
    type="text"
    name="title"
    placeholder="Adicionar tarefa..."
    [(ngModel)]="title"
  />
  <button type="submit" class="btn">
    Salvar
  </button>
</form>
